/* Healthy Box — curseur avant/apres. Gere plusieurs instances par page. */
(function () {
  function init(bloc) {
    var champ = bloc.querySelector('.hb-ab__champ');
    if (!champ) return;
    function maj() { bloc.style.setProperty('--hb-x', champ.value + '%'); }
    champ.addEventListener('input', maj);
    maj();
  }
  function tout() {
    document.querySelectorAll('.hb-ab').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tout);
  } else {
    tout();
  }
  document.addEventListener('shopify:section:load', tout);
})();
